__turbopack_context__.v({
  "component": "style-module-scss-module__z4-rgq__component",
  "cta-and-video-container": "style-module-scss-module__z4-rgq__cta-and-video-container",
  "cta-buttons": "style-module-scss-module__z4-rgq__cta-buttons",
  "cta-container": "style-module-scss-module__z4-rgq__cta-container",
  "cta-text": "style-module-scss-module__z4-rgq__cta-text",
  "invisible": "style-module-scss-module__z4-rgq__invisible",
  "media-container": "style-module-scss-module__z4-rgq__media-container",
  "play-button": "style-module-scss-module__z4-rgq__play-button",
  "slide": "style-module-scss-module__z4-rgq__slide",
  "slider": "style-module-scss-module__z4-rgq__slider",
});
